import type { IAiUsageConfig } from '@ztechapps/common.contract'
import { AiBillingScopeEnum, AiCatalogWriteGateEnum } from '@ztechapps/common.contract'

export const haulerAiUsageConfig: IAiUsageConfig = {
  billingScope: AiBillingScopeEnum.Tenant,
  defaultCurrency: 'USD',
  catalogWriteGate: AiCatalogWriteGateEnum.SuperAdmin,
}
